import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { authFlowDebug } from '../utils/auth-flow-debug.util';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  if (auth.isLoggedIn()) {
    return true;
  }
  authFlowDebug.log('auth_guard_redirect', 'authGuard', {
    detail: 'User not logged in; redirecting to landing login.',
    level: 'warn',
  });
  auth.redirectToLogin('authGuard', 'not_logged_in');
  return false;
};

export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.isLoggedIn()) {
    return true;
  }
  return router.createUrlTree(['/dashboard']);
};
